@for (colorInfo of colors; track colorInfo.key) {
  <div>
    <div>
      <h2>{{ 'COLORS.' + colorInfo.key | translate }}</h2>
    </div>
    <p [innerHTML]="'COLORS.' + colorInfo.key + '.INFO' | translate"></p>
    <div>
      <div #color class="color" style="background-color: var({{ colorInfo.varName }})" [class.border]="colorInfo.border">
        <div class="shade-text">
          <div class="text normal">{{ colorToHex(color) }}</div>
          @for (kv of colorToHsl(color) | keyvalue; track kv) {
            <div class="text normal">{{ kv.key }} : {{ kv.value }}</div>
          }
        </div>
      </div>

      @if (colorInfo.hueIds) {
        <ul>
          @for (hueId of colorInfo.hueIds; track hueId) {
            <li>
              <div #hue class="shade" style="background-color: var({{ colorInfo.varName }}{{ hueId === 500 ? '' : '-' + hueId }})"></div>
              <div class="shade-text">
                <div class="text normal">{{ hueId === 500 ? '(' + hueId + ')' : hueId }}</div>
                <div class="text normal">{{ colorToHex(hue) }}</div>
                @for (kv of colorToHsl(hue) | keyvalue; track kv) {
                  <div class="text normal">{{ kv.key }} : {{ kv.value }}</div>
                }
              </div>
            </li>
          }
        </ul>
      }
    </div>
  </div>
}
